import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ProgrammeRoutingModule } from './programme-routing.module';
import { ProgrammeComponent } from './programme.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { ProgrammeUnitComponent } from './programme-unit/programme-unit.component';
import {MatTabsModule} from '@angular/material/tabs';
import {MatMenuModule} from '@angular/material/menu';
import { ProgrammeUnitMobileComponent } from './programme-unit-mobile/programme-unit-mobile.component';


@NgModule({
  declarations: [
    ProgrammeComponent,
    ProgrammeUnitComponent,
    ProgrammeUnitMobileComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatTabsModule,
    MatMenuModule,
    ProgrammeRoutingModule
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]  
})
export class ProgrammeModule { }
